import {
  SWS_HELP_LINK,
  SWS_NEWS_LINK,
  SWS_PLANS_LINK,
  SWS_FINANCIAL_SERVICES_GUIDE,
  COMPANY_ADDRESS,
  APPSTORE_APP_LINK,
  GOOGLE_PLAY_APP_LINK,
  SWS_TWITTER_LINK,
  SWS_LINKEDIN_LINK,
  SWS_YOUTUBE_LINK,
  SWS_PRO_PROGRAM,
  SWS_WHATS_NEW_LINK,
} from '@/constants';
import {
  Wrapper,
  SWSLogo,
  AppBadge,
  PrimaryLinks,
  SecondaryLinks,
  MarketPageLinks,
  Disclaimer,
  Address,
  StyledA,
  LogoContainer,
  LeftColumn,
} from './styled';
import { Row, Column } from '@simplywallst/ui-core';
import Break from '@components/Break';
import SWSLogoWhite from '@assets/images/logo/sws-logo-white.svg';
import SWSLogoBlack from '@assets/images/logo/sws-logo-black.svg';
import LinkedInIcon from '@assets/images/logo/linkedin.svg';
import TwitterIcon from '@assets/images/logo/twitter.svg';
import YouTubeIcon from '@assets/images/logo/youtube-logo.svg';
import { useTheme } from '@simplywallst/ui-core';
import { RouterLink } from '@redux-first-router-link';
import {
  ROUTE_PRIVACY_POLICY_FULL,
  ROUTE_TERMS_AND_CONDITIONS_FULL,
  ROUTE_CAREERS,
  ROUTE_ABOUT,
  ROUTE_PODCASTS,
  ROUTE_WELCOME,
  ROUTE_MARKET,
  ROUTE_AFFILIATE_PROGRAM,
} from '@/constants/routes';
import { useCloudflareImage } from '@/hooks/useCloudflareImage';
import { useTranslation } from '@/hooks/useTranslation';

interface Props {
  center?: boolean;
  showClearbit?: boolean; //Will be removed later once company logos are stored in backend
}
/**
 *
 * @deprecated
 *
 */
const Footer = ({ center, showClearbit }: Props) => {
  const theme = useTheme();
  const appleBadge = useCloudflareImage({
    src: 'https://simplywall.st/static/legacy/images/landing/itunesbadge.png',
    width: 135,
  });
  const googlePlayBadge = useCloudflareImage({
    src: 'https://simplywall.st/static/legacy/images/landing/googleplaysm.png',
    width: 135,
  });
  const t = useTranslation();

  if (RUNTIME_ENV === 'native') return null;

  return (
    <Wrapper center={center} data-cy-id="footer">
      <Row>
        <LeftColumn colMd={center ? 12 : 6}>
          <SWSLogo>
            {theme.appTheme === 'dark' ? <SWSLogoWhite /> : <SWSLogoBlack />}
          </SWSLogo>
          <Address>
            Simply Wall St<sup>&trade;</sup>
            <br />
            Simply Wall Street Pty Ltd
            <br />
            {COMPANY_ADDRESS}
          </Address>
          <LogoContainer
            justifyContentMd={center ? 'center' : 'flex-start'}
            justifyContent="center"
          >
            <StyledA
              href={SWS_LINKEDIN_LINK}
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              <LinkedInIcon />
            </StyledA>
            <StyledA
              href={SWS_TWITTER_LINK}
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              <TwitterIcon />
            </StyledA>
            <StyledA
              href={SWS_YOUTUBE_LINK}
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              <YouTubeIcon />
            </StyledA>
          </LogoContainer>
          <AppBadge
            href={APPSTORE_APP_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <img
              src={appleBadge}
              alt="Download on the App Store"
              width="135"
              height="40"
              loading="lazy"
            />
          </AppBadge>
          <AppBadge
            href={GOOGLE_PLAY_APP_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <img
              src={googlePlayBadge}
              width="135"
              height="40"
              alt="Get it on Google Play"
              loading="lazy"
            />
          </AppBadge>
        </LeftColumn>
        <Column colMd={center ? 12 : 6}>
          <MarketPageLinks>
            <span>{t('app.footer.links.popularMarkets')}</span>
            <PrimaryLinks>
              <RouterLink
                to={{ type: ROUTE_MARKET, payload: { market: 'us' } }}
              >
                US
              </RouterLink>
              <RouterLink
                to={{ type: ROUTE_MARKET, payload: { market: 'au' } }}
              >
                AU
              </RouterLink>
              <RouterLink
                to={{ type: ROUTE_MARKET, payload: { market: 'gb' } }}
              >
                UK
              </RouterLink>
              <RouterLink
                to={{ type: ROUTE_MARKET, payload: { market: 'in' } }}
              >
                IN
              </RouterLink>
              <RouterLink
                to={{ type: ROUTE_MARKET, payload: { market: 'ca' } }}
              >
                CA
              </RouterLink>
              <RouterLink
                to={{ type: ROUTE_MARKET, payload: { market: 'za' } }}
              >
                ZA
              </RouterLink>
            </PrimaryLinks>
          </MarketPageLinks>
          <PrimaryLinks>
            <RouterLink to={{ type: ROUTE_ABOUT }}>
              {t('app.footer.links.aboutUs')}
            </RouterLink>
            <RouterLink to={{ type: ROUTE_CAREERS }}>
              {t('app.footer.links.careers')}
            </RouterLink>
            <a href={SWS_PLANS_LINK} rel="nofollow">
              {t('app.footer.links.plans')}
            </a>
            <RouterLink to={{ type: ROUTE_WELCOME }}>
              {t('app.footer.links.login')}
            </RouterLink>
            <Break mdUp />
            <a
              href={SWS_HELP_LINK}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {t('app.footer.links.help')}
            </a>
            <a href={SWS_NEWS_LINK} rel="nofollow">
              {t('app.footer.links.latest')}
            </a>
            <RouterLink to={{ type: ROUTE_PODCASTS }}>
              {t('app.footer.links.podcasts')}
            </RouterLink>
            <RouterLink to={{ type: ROUTE_AFFILIATE_PROGRAM }}>
              {t('app.footer.links.affiliate')}
            </RouterLink>
            <a
              href={SWS_PRO_PROGRAM}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {t('app.footer.links.business')}
            </a>
            <a
              href={SWS_WHATS_NEW_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('app.footer.links.whatsNew')}
            </a>
          </PrimaryLinks>
          <SecondaryLinks>
            <a
              href={SWS_FINANCIAL_SERVICES_GUIDE}
              rel="noopener noreferrer"
              target="_blank"
            >
              {t('app.footer.links.financialServices')}
            </a>
            <RouterLink to={{ type: ROUTE_TERMS_AND_CONDITIONS_FULL }}>
              {t('app.footer.links.terms')}
            </RouterLink>
            <RouterLink to={{ type: ROUTE_PRIVACY_POLICY_FULL }}>
              {t('app.footer.links.privacy')}
            </RouterLink>
            {showClearbit && (
              <a
                href="https://clearbit.com"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                {t('app.footer.links.clearbit')}
              </a>
            )}
          </SecondaryLinks>
        </Column>
      </Row>
      <Disclaimer>
        Simply Wall Street Pty Ltd (ACN 600 056 611), is a Corporate Authorised
        Representative (Authorised Representative Number: 467183) of Sanlam
        Private Wealth Pty Ltd (AFSL No. 337927). Any advice contained in this
        website is general advice only and has been prepared without considering
        your objectives, financial situation or needs. You should not rely on
        any advice and/or information contained in this website and before
        making any investment decision we recommend that you consider whether it
        is appropriate for your situation and seek appropriate financial,
        taxation and legal advice. Please read our Financial Services Guide
        before deciding whether to obtain financial services from us.
      </Disclaimer>
    </Wrapper>
  );
};

export default Footer;
